import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'
import storeInit from 'initializations/pages/SiloBlockPage'

export class Main extends AbstractView {
  constructor(domElementId) {
    return super(domElementId);
  }

  init() {
    storeInit.init("siloBlockPage")

    const SiloPage = () => import(/* webpackChunkName: "repat-form-page" */ 'containers/Pages/SiloBlockPage')

    new Vue({
      el: "#" + this.elemId,
      store,
      render: h => h(SiloPage)
    })
  }
}
